var XPortal = XPortal || {};
XPortal.SectionBlock = (function () {
    var self =
    {
        items: [],
        Init: function (cntr) {
            cntr = $(cntr ? cntr : "body");
            cntr.find("section.xsection").each(function () {
                initFor(this);
            });
        },      
        onRequestEnd: function (e, r, c, o) {
            showSelectionContainer(c, o, false);
        },
        showSelection: function (c, o, di, diId) {
            showSelectionContainer(c, o, true);
            if (c.attr("data-pid") == diId) return;

            c.attr("data-pid", diId);
            c.find(".section-rel-parentinfo").each(function () {
                var $x = $(this);
                if ($x.closest("section.xsection")[0] === c[0]) {//in case when we have deep structure - only first level children should be setup
                    $x.val((o.ParentGridId || "") + "#|#" + (di.UniqueId || diId || ""));
                    $x.trigger("modified", [{ parentElementId: di.UniqueId || diId, parentNodeId: o.ParentGridId }]);
                }
            });
        },
        getOptions: function (c) {
            let o = XPortal.Main.GetSettingsFor(c);
            o.nodeId = Number(o.nid || o["edit-id"]);

            if (!self.items[o.nodeId]) {
                o = self.items[o.nodeId] = Object.assign(o, XPortal.Utils.readJsonStr(o.opts, {}));
                c.removeAttr("data-opts");
                delete o.opts;
            }
            o = self.items[o.nodeId];
            o.onRequestEnd = function (e, r) {
                self.onRequestEnd(e, r, c, o);
            };
            return o;
        },
        getBlocks: function (container) {
            return container.children('.xsection, .xblock, .grid-parent');
        },        
        getBlockById: function (container, id) {
            let res = null;
            self.getBlocks(container).each((xi, x) => {
                    let o = XPortal.Main.GetSettingsFor($(x));
                    o.nodeId = Number(o.nid || o["edit-id"]);
                    if (o.nodeId == id) res = $(x);
                });
            return res;
        }
    };

    function getGridInfo(id) {
        const items = $(".grid-parent .entity-grid");
        for (let i = 0; i < items.length; i++) {
            const grdId = $(items[i]).attr("data-id");
            if (grdId == id) return XPortal.Grid.GetGridInfo($(items[i]));
        }
        return { grid: $() };
    }
    function initFor(cnrol) {
        cnrol = cnrol ? $(cnrol) : false;
        if (!(cnrol) || cnrol.length < 1) return null;

        const doptions = self.getOptions(cnrol);
        if (cnrol.attr("data-processed") == "1") return doptions;
        cnrol.attr("data-processed", "1");

        initSrcGrid(cnrol, doptions);
        XPortal.SectionExpandCollapse.InitFor(cnrol, doptions);
        showSelectionContainer(cnrol, doptions);

        const xcontent = $(cnrol).find('> .xbgdecoration-wrap > .section-content > .xcontent');

        if (xcontent.find('> .dr-field-set').length > 0) {
            xcontent.addClass('align-start');
        }
    };
    function initSrcGrid(cnrol, opts) {
        if (!opts.ParentGridId) return;
        let gridInfo = getGridInfo(opts.ParentGridId);
        if (!gridInfo.grid.length) return;
        gridInfo.grid.off("grid.requestEnd", opts.onRequestEnd);
        gridInfo.grid.on("grid.requestEnd", opts.onRequestEnd);

        let i = 1000;
        self.showSelection(cnrol, opts, {}, XPortal.Utils.guid());
        waitFor(function () {
            gridInfo = getGridInfo(opts.ParentGridId);
            if (!gridInfo.kgrid && i-- > -1) return false;
            if (i < 0) return true;
            self.showSelection(cnrol, opts, {}, XPortal.Utils.guid());
            gridInfo.kgrid.bind("change", function () {
                const sel = this.dataItem(this.select());
                const selId = sel ? sel.UniqueId : "";
                self.showSelection(cnrol, opts, sel, selId);
            });
            if (gridInfo.kgrid.dataSource.iRequestEnd && !opts.isinitialized) opts.onRequestEnd(null, gridInfo.kgrid.dataSource.iRequestEnd);//when grid already with data,but we not processed this data yet
            return true;
        }, waitFor);
    };
    function showSelectionContainer(c, o, isshow) {

    };
    function waitFor(onAction, onFalse) {
        if (!onAction()) setTimeout(function () {
            onFalse(onAction, onFalse);
        }, 100);
    };
    $(document).on("modified", ".dashboard-async-item .section-rel-parentinfo", function () {
        var frm = $(this).closest(".dashboard-async-item");
        if (frm.length < 1) return;
        setTimeout(function () {
            frm.submit();
            XPortal.Loader.show({ selector: frm });
        }, 500);
    });
    $(document).on("modified", ".grid-parent .section-rel-parentinfo", function () {
        var grdprnt = $(this).closest(".grid-parent");
        var grid = grdprnt.find(".k-grid");
        if (grid.length > 0)
            setTimeout(function () {
                var g = grid.data("kendoGrid");
                if (g) g.dataSource.read();
            }, 500);
    });

    $(document).on("modified", ".scheduler-parent .section-rel-parentinfo", function (event, param) {
        var schedularHtml = $(this).closest(".scheduler-parent").find(".k-scheduler");
        var schedular = schedularHtml.data("kendoScheduler");
        if (schedular != null) {
            setTimeout(function () {
                ///this magic don't need to be so hard''''
                var schedularId = schedular.element.attr("id").split('-').pop();
                var coptions = XPortal.Calendar.dictionaryOptions[schedularId];
                coptions.parentElementId = param.parentElementId;
                coptions.parentNodeId = param.parentNodeId;
                ///end of :this magic don't need to be so hard''''
                schedular.refresh();
                schedular.trigger("navigate");
            }, 500);
        }
    });
    return self;
}());